import React, { useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import Select from "react-select";
import "./InquiryModal.css";
import ExploreBtn from "../common-btn/explore_btn/ExploreBtn";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Succes_lottie from "../../animation/success_lottie/Succes_lottie";
import {
  addProductEnquiry,
  addContactUs,
} from "../../../utils/apis/enquiry/Enquiry";

const subjectOptions = [
  { value: "general", label: "General Inquiry" },
  { value: "support", label: "Support" },
  { value: "business", label: "Business" },
];

export default function InquiryModal({ show, handleClose, product_id, type }) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();
  // const handleSubmit = () => {
  //   setIsSubmitted(true);

  //   setTimeout(() => {
  //     handleClose();
  //     navigate("/home");
  //   }, 3000);
  // };

  const {
    register,
    reset,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({});

  const onSubmit = async (data) => {
    try {
      let payload = {
        ...data,
      };

      if (type === "product") {
        payload.product_id = product_id || null;
      }

      let res;

      if (type === "product") {
        res = await addProductEnquiry(payload);
      } else {
        res = await addContactUs(payload);
      }

      if (res?.success) {
        setIsSubmitted(true);

        setTimeout(() => {
          handleClose();
          navigate("/");
        }, 3000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!show) {
      reset(); // clears all fields
      setIsSubmitted(false); // reset success state too
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="inquiry-modal"
    >
      <div className="inquiry-box">
        <div className="inquiry-header">
          <h5>{isSubmitted ? "INQUIRE DONE" : "INQUIRE NOW"}</h5>
          <span onClick={handleClose} className="close-btn">
            ✕
          </span>
        </div>

        {/* FORM */}
        {!isSubmitted && (
          <Form
            className="inquiry-form form-wrapper"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Form.Group className="mb-3 grp">
              <Form.Label>Full Name*</Form.Label>
              <Form.Control
                name="name"
                placeholder="Enter Your Name"
                {...register("name", {
                  required: "Name is required",

                  maxLength: {
                    value: 100,
                    message: "Name Cannot Exceed 100 Characters",
                  },
                })}
              />
              {errors?.name && (
                <Form.Text className="text-danger">
                  {errors?.name?.message}
                </Form.Text>
              )}
            </Form.Group>

            <div className="row">
              <div className="col-6">
                <Form.Group>
                  <Form.Label>Email Address*</Form.Label>
                  <Form.Control
                    name="email"
                    placeholder="Enter Your Email"
                    {...register("email", {
                      required: "Email is required",
                      maxLength: {
                        value: 100,
                        message: "Email Cannot Exceed 100 Characters",
                      },
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: "Invalid email address",
                      },
                    })}
                  />
                  {errors?.email && (
                    <Form.Text className="text-danger">
                      {errors?.email?.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </div>
              <div className="col-6">
                <Form.Group>
                  <Form.Label>Phone No.*</Form.Label>
                  <Form.Control
                    name="contact_no"
                    placeholder="Enter Your Phone No."
                    {...register("contact_no", {
                      required: "Phone No. is required",
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: "Enter a valid 10-digit number",
                      },
                    })}
                  />
                  {errors?.contact_no && (
                    <Form.Text className="text-danger">
                      {errors?.contact_no?.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </div>
            </div>

            <Form.Group className="mt-3 grp">
              <Form.Label>Subject*</Form.Label>
              <Controller
                name="subject"
                control={control}
                rules={{ required: "Subject is required" }}
                render={({ field }) => (
                  <Select
                    options={subjectOptions}
                    placeholder="Select Subject"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    //map stored value back to option
                    value={
                      subjectOptions.find((opt) => opt.label === field.value) ||
                      null
                    }
                    //store label
                    onChange={(val) => field.onChange(val?.label)}
                  />
                )}
              />
              {errors?.subject && (
                <Form.Text className="text-danger">
                  {errors?.subject?.message}
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className="mt-3 grp">
              <Form.Label>Message*</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="message"
                placeholder="Type Message..."
                {...register("message", {
                  required: "Message is required",

                  maxLength: {
                    value: 300,
                    message: "Message Cannot Exceed 300 Characters",
                  },
                })}
              />
              {errors?.message && (
                <Form.Text className="text-danger">
                  {errors?.message?.message}
                </Form.Text>
              )}
            </Form.Group>

            <div className="submit-btn w-100 mt-4">
              <ExploreBtn text="Submit Inquiry" type="submit" />
            </div>
          </Form>
        )}

        {/* SUCCESS */}
        {isSubmitted && (
          <div className="success">
            <div>
              <Succes_lottie />
            </div>
            <p className="desc">
              Thank You!
              <br />
              Your Inquiry Has Been Submitted Successfully!!! Our Team Will
              Respond Within 24 Hours
            </p>

            <div className="submit-btn w-100 mt-4">
              <ExploreBtn text="Back To Home" onClick={() => navigate("/")} />
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}
